import { useEffect, useMemo } from "react";

import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";

import { deserialize } from "@/dashboard-design-system/RichTextInput/helpers";

type DefaultHtmlValuePluginProps = {
  defaultValue?: string | null;
};

export const DefaultValuePlugin = ({ defaultValue }: DefaultHtmlValuePluginProps) => {
  const [editor] = useLexicalComposerContext();

  const { isLexicalRichText, value } = useMemo(() => deserialize(defaultValue), [defaultValue]);

  useEffect(() => {
    if (typeof DOMParser === "undefined" || !value) {
      return;
    }

    editor.update(() => {
      if (isLexicalRichText) {
        const parser = new DOMParser();
        const dom = parser.parseFromString(value, "text/html");
        const nodes = $generateNodesFromDOM(editor, dom);
        const root = $getRoot();
        root.clear();
        root.append(...nodes);
      } else {
        const root = $getRoot();
        root.clear();
        const node = $createParagraphNode();
        node.append($createTextNode(value));
        root.append(node);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLexicalRichText, value]);

  return null;
};
